export class SlotModel {
    constructor(public valueInMinutes: number, public displayText: string) {}
}
